import type { Component } from 'vue'

import { IconAvatar } from '@ds/icons/IconAvatar'
import { IconContact } from '@ds/icons/IconContact'
import { IconInfo } from '@ds/icons/IconInfo'
import { IconMoney } from '@ds/icons/IconMoney'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconRefund } from '@ds/icons/IconRefund'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'
import { IconSim } from '@ds/icons/IconSim'
import { IconSiren } from '@ds/icons/IconSiren'
import { IconTools } from '@ds/icons/IconTools'
import { IconTradeIn } from '@ds/icons/IconTradeIn'
import { IconTruck } from '@ds/icons/IconTruck'

const FAQ_CATEGORIES = [
  { ids: [1462339, 1460654], icon: IconInfo, dataQa: 'faq-category-about' },
  { ids: [1462341, 1460656], icon: IconAvatar, dataQa: 'faq-category-account' },
  {
    ids: [1462344, 1460659],
    icon: IconShoppingBag,
    dataQa: 'faq-category-buying',
  },
  { ids: [1462348, 1460663], icon: IconMoney, dataQa: 'faq-category-payments' },
  { ids: [1462352, 1460667], icon: IconTruck, dataQa: 'faq-category-shipping' },
  { ids: [1462356, 1460671], icon: IconSiren, dataQa: 'faq-category-orders' },
  {
    ids: [1462360, 1460675],
    icon: IconTools,
    dataQa: 'faq-category-troubleshooting',
  },
  {
    ids: [1462366, 1460681],
    icon: IconContact,
    dataQa: 'faq-category-contact',
  },
  {
    ids: [1462368, 1460683],
    icon: IconQuality,
    dataQa: 'faq-category-warranty',
  },
  { ids: [1462371, 1460686], icon: IconRefund, dataQa: 'faq-category-returns' },
  { ids: [1462374, 1460689], icon: IconTradeIn, dataQa: 'faq-category-sells' },
  { ids: [1462379], icon: IconSim, dataQa: 'faq-category-mobile-plan' },
] as const

export const FAQ_CATEGORIES_CONFIG: Record<
  string,
  { icon: Component; dataQa: string }
> = Object.fromEntries(
  FAQ_CATEGORIES.flatMap(({ ids, ...meta }) =>
    ids.map((id) => [id.toString(), meta]),
  ),
)
